
import XHeader from 'vux/src/components/x-header/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import { common, commonApi } from '@/common/index'

export default {
name: 'lockAmount',
components: {
XHeader,
Tab,
TabItem,
},
data() {
return {
nowIndex: 0,// 当前导航
depositList: [],// 充值
downLoading: false, // 优惠
discountsList: [],
}
},
methods: {
handleOnItemClick(val) {
this.nowIndex = val;
if(val === 0) return this.$router.replace({path: '/My/lock-amount/depositList'})
if(val === 1) return this.$router.replace({path: '/My/lock-amount/discountList'})
}
},
created() {
this.nowIndex = this.$route.path ==='/My/lock-amount/depositList' ? 0 : 1
},
mounted() {

},
destroyed(){

}
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/LockAmount/index.vue